import { render, staticRenderFns } from "./IntegrationTab.vue?vue&type=template&id=f131ef8c&"
import script from "./IntegrationTab.vue?vue&type=script&lang=js&"
export * from "./IntegrationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports